import React                from 'react';
import { BarChart }         from '@mui/x-charts/BarChart';
import { useTranslation }   from 'react-i18next';
import { axisClasses }      from '@mui/x-charts/ChartsAxis';
import { 
    Card, 
    CardContent, 
    Box, 
    Container 
} from '@mui/material';



const InfoCard = ({ title, data, color }) => {
    const { t } = useTranslation();

    const chartSetting = {
        height: 200,
        yAxis: [],
        series: [{ dataKey: 'value', label: title, color: color }],
        sx: {
            [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
                transform: 'translateX(-10px)',
            },
        },
    };

    return (
        <Container maxWidth="false">
            <Card
                sx={{
                    width: '100%',
                    height: '18vh', 
                    paddingY: { xs: 2, lg: 3},
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                    borderRadius: '30px',
                    background: 'linear-gradient(145deg, #fefefe, #f5f5f5)',
                    border: '1px solid #cccccc'
                }}
            >
                <CardContent sx={{ p: 0 }}>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1}}>
                        <BarChart
                            dataset={data}
                            xAxis={[{ scaleType: 'band', dataKey: 'label', tickPlacement: 'middle' }]}
                            {...chartSetting}
                            borderRadius={5}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Container>
    );
};

export default InfoCard;
